import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import TimeSlotItem from './TimeSlotsItem.js';

const TimeSlotItemContainer = (_param)=>{
    var { onSelect , slot  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "onSelect",
        "slot"
    ]);
    const handleOnSelect = React.useCallback(()=>onSelect(slot)
    , [
        onSelect,
        slot
    ]);
    return /*#__PURE__*/ React.createElement(TimeSlotItem, swcHelpers.extends({}, rest, {
        onSelect: handleOnSelect
    }));
};
var TimeSlotsItem = TimeSlotItemContainer;

export { TimeSlotsItem as default };
//# sourceMappingURL=TimeSlotsItemContainer.js.map
